<template>
    <div>
        <!-- 常规音乐 -->
        <audio
            ref="regularMusic"
            :hidden="true"
            autoplay="autoplay"
            loop
            controls>
            <source type="audio/ogg">
            <source src="@/assets/audio/regular.mp3" type="audio/mpeg">
        </audio>
    </div>
</template>
<script>


    export default {
        data() {
            return {
                
            }
        },
        mounted() {
            // let t = setTimeout(() => {
                this.play();
            // }, 4000);
        },
        methods: {
            play() {
                this.$refs.regularMusic.play();
            },
        }
    }
</script>

<style lang="scss" scoped type="text/css">
    
</style>



// WEBPACK FOOTER //
// src/components/regularMusic/RegularMusic.vue